import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web/build/player/lottie_light';
import { Container } from '@pella/sash-framework';
import * as animationData from './loading.json';

import styles from './index.module.scss';

const LoadingOverlay = ({ fixed = true, svgSize = 300, stickySvg, className, msg, ...other }) => {
	const loaderRef = useRef(null);

	useEffect(() => {
		lottie.loadAnimation({
			container: loaderRef.current,
			animationData: animationData,
			loop: true,
			autoplay: true,
			renderer: 'svg',
			rendererSettings: {
				title: 'Loading',
			},
		});
	}, []);

	return (
		<div
			className={`${styles.overlayLoader} ${!fixed ? 'absolute' : 'fixed'} ${!fixed && stickySvg ? `justify-start` : 'justify-center'} noJs-loading flex h-full w-full flex-col items-center ${className || ''}`}
			data-testid='loading-overlay'
			{...other}
		>
			{msg && (
				<Container width={800}>
					<p className={`${styles.overlayLoader_Msg} text-center text-2xl leading-tight xl:text-4xl`}>{msg}</p>
				</Container>
			)}

			<div
				ref={loaderRef}
				style={{ width: svgSize, height: svgSize }}
				className={stickySvg ? styles.loadingAnim : null}
			/>

			<noscript>
				<style
					dangerouslySetInnerHTML={{
						__html: `.noJs-loading { display: none !important; }`,
					}}
				/>
			</noscript>
		</div>
	);
};

LoadingOverlay.propTypes = {
	className: PropTypes.string,
	fixed: PropTypes.bool,
	msg: PropTypes.string,
	svgSize: PropTypes.number,
	stickySvg: PropTypes.bool,
};

export default LoadingOverlay;
